<ng-content></ng-content>
<ng-container *ngIf="components$ | async as components">
  <li py-megamenu-list-item *ngFor="let component of components" [showLinkArrow]="false">
    <cx-generic-link [url]="component.linkLoc">{{ component?.titleLoc }}</cx-generic-link>
  </li>
</ng-container>
